<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '../SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: 'マスターユーザー',
        items: [
          {
            text: 'ライターレポート',
            router: { name: 'masterWriterWriterReports' }
          }
        ]
      }
    ]
  })
}
</script>
